import { useCallback, useMemo, useState } from 'react';
import { useBoolState } from '@/hooks/state/useBoolState';
export const useRfpClientViewRequestTable = (args) => {
    const { rows } = args;
    // 一覧のチェックボックス 管理
    const [selectedIds, changeSelectedIds] = useState([]);
    // 全選択チェックボックス 管理
    const [allSelectChecked, changeAllSelectChecked] = useState(false);
    // 開示 user 管理
    const [viewRequestIds, setViewRequestIds] = useState([]);
    // 提案希望 user 管理
    const [proposalRequestIds, setProposalRequestIds] = useState([]);
    // 開示モーダル 表示制御
    const { boolState: isShowViewRequestModal, changeFalse: hideViewRequestModal, changeTrue: showViewRequestModal, } = useBoolState();
    // 提案希望モーダル 表示制御
    const { boolState: isShowProposalRequestModal, changeFalse: hideProposalRequestModal, changeTrue: showProposalRequestModal, } = useBoolState();
    // 全id
    const allIds = useMemo(() => rows.map(({ id }) => id), [rows]);
    // 開示対象 User
    const viewRequestUsers = useMemo(() => viewRequestIds
        .map((viewRequestId) => { var _a; return (_a = rows.find(({ id }) => id === viewRequestId)) === null || _a === void 0 ? void 0 : _a.user; })
        .filter((user) => !!user), [rows, viewRequestIds]);
    // 提案希望対象 User
    const proposalRequestUsers = useMemo(() => proposalRequestIds
        .map((proposalRequestId) => { var _a; return (_a = rows.find(({ id }) => id === proposalRequestId)) === null || _a === void 0 ? void 0 : _a.user; })
        .filter((user) => !!user), [rows, proposalRequestIds]);
    // 一括開示できる(選択されている + 未開示) Id
    const { canViewRequestBulk, viewRequestBulkIds } = useMemo(() => {
        const ids = rows
            .filter((r) => selectedIds.includes(r.id) && !r.isDiscloseApproved)
            .map((v) => v.id);
        return {
            canViewRequestBulk: ids.length > 0,
            viewRequestBulkIds: ids,
        };
    }, [selectedIds, rows]);
    // 一括提案希望できる(選択されている + 送付済みじゃない + 提案済じゃない) Id
    const { canProposalRequestBulk, proposalRequestBulkIds } = useMemo(() => {
        const ids = rows
            .filter((r) => selectedIds.includes(r.id) && !r.isProposalRequested && !r.hasOffered)
            .map((v) => v.id);
        return {
            canProposalRequestBulk: ids.length > 0,
            proposalRequestBulkIds: ids,
        };
    }, [rows, selectedIds]);
    /**
     * 一覧チェックボックス 変更時
     */
    const onChangeCheck = useCallback((id) => {
        changeSelectedIds((prev) => {
            const newValue = [...prev];
            if (prev.includes(id)) {
                const index = newValue.indexOf(id);
                newValue.splice(index, 1);
            }
            else {
                newValue.push(id);
            }
            // 全選択 管理
            if (newValue.length === allIds.length) {
                // 全てにチェックが入った場合 全選択
                changeAllSelectChecked(true);
            }
            else {
                // 全てにチェックが入っていない場合 全選択解除
                changeAllSelectChecked(false);
            }
            return newValue;
        });
    }, [allIds, changeAllSelectChecked, changeSelectedIds]);
    /**
     * 全選択 チェック変更時
     */
    const onChangeAllCheckBox = useCallback(() => {
        changeAllSelectChecked((prev) => {
            if (prev) {
                // 全選択 解除
                changeSelectedIds([]);
                return false;
            }
            // 全選択
            changeSelectedIds(allIds);
            return true;
        });
    }, [allIds, changeSelectedIds]);
    /**
     * 開示ボタン クリック時時
     */
    const onClickViewRequest = useCallback((id) => {
        setViewRequestIds([id]);
        showViewRequestModal();
    }, [setViewRequestIds, showViewRequestModal]);
    /**
     * 一括開示ボタン クリック時時
     */
    const onClickBulkViewRequest = useCallback(() => {
        setViewRequestIds(viewRequestBulkIds);
        showViewRequestModal();
    }, [viewRequestBulkIds, setViewRequestIds, showViewRequestModal]);
    /**
     * 提案希望ボタン クリック時時
     */
    const onClickProposalRequest = useCallback((id) => {
        setProposalRequestIds([id]);
        showProposalRequestModal();
    }, [setProposalRequestIds, showProposalRequestModal]);
    /**
     * 一括提案希望ボタン クリック時時
     */
    const onClickBulkProposalRequest = useCallback(() => {
        setProposalRequestIds(proposalRequestBulkIds);
        showProposalRequestModal();
    }, [proposalRequestBulkIds, setProposalRequestIds, showProposalRequestModal]);
    return {
        allSelectChecked,
        canProposalRequestBulk,
        canViewRequestBulk,
        hideProposalRequestModal,
        hideViewRequestModal,
        isShowProposalRequestModal,
        isShowViewRequestModal,
        onChangeAllCheckBox,
        onChangeCheck,
        onClickBulkProposalRequest,
        onClickBulkViewRequest,
        onClickProposalRequest,
        onClickViewRequest,
        proposalRequestIds,
        proposalRequestUsers,
        selectedIds,
        viewRequestIds,
        viewRequestUsers,
    };
};
